import { render, staticRenderFns } from "./Compose.PanelText.vue?vue&type=template&id=b397069e&scoped=true&"
import script from "./Compose.PanelText.vue?vue&type=script&lang=js&"
export * from "./Compose.PanelText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b397069e",
  null
  
)

export default component.exports